export default __webpack_public_path__ + "static/header-74652182a046575dea1db9088e365b72.jpg";